import { useEffect } from 'react';
import { Outlet, useNavigate } from '@tanstack/react-router';
import { useAuth } from '@/lib/auth';
import { ConnectionError } from '@/components/connection-error';

export function AppLayout() {
  const { profile, loading, profileLoading, profileError, refreshProfile } = useAuth();
  const navigate = useNavigate();

  // Redirige vers l'onboarding seulement si le profil est RÉELLEMENT absent.
  // Jamais quand le fetch a échoué faute de réseau : sinon un utilisateur
  // existant hors ligne se retrouve éjecté vers la création de compte.
  useEffect(() => {
    if (loading || profileLoading) return;
    if (!profile && !profileError) {
      navigate({ to: '/onboarding' });
    }
  }, [loading, profileLoading, profile, profileError, navigate]);

  // Réessaie automatiquement de charger le profil dès le retour du réseau.
  useEffect(() => {
    if (!profileError) return;
    const onOnline = () => void refreshProfile();
    window.addEventListener('online', onOnline);
    return () => window.removeEventListener('online', onOnline);
  }, [profileError, refreshProfile]);

  if (loading || profileLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <span className="text-ink-400 text-sm">Chargement…</span>
      </div>
    );
  }

  if (!profile && profileError) {
    return <ConnectionError variant={profileError} onRetry={() => void refreshProfile()} />;
  }

  if (!profile) return null;

  return (
    <div className="bg-background min-h-screen">
      <Outlet />
    </div>
  );
}
